import { render, staticRenderFns } from "./detail-payment.vue?vue&type=template&id=7d486f54&"
import script from "./detail-payment.vue?vue&type=script&lang=js&"
export * from "./detail-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports